import axios from "axios";
import { ApiFetchData } from "../data/api";

/**
 * Execute HTTP POST-request.
 * @param url   The url to send request to.
 * @param body  The body to send with the request.
 * @param token Optional token to send with the request.
 * @return      Result of the API-fetch.
 */
export async function httpPost<T>(url: string, body: object, token?: string): Promise<ApiFetchData<T>> {
    try {
        let headers: { [key: string]: string } = { "Content-Type": "application/json" };
        if (token) headers["Session-Token"] = token;
        const res = await axios.post(url, JSON.stringify(body), { headers: headers });
        if (res.status === 204) return { success: true, data: {} as T };
        if (
            res.status >= 200 &&
            res.status < 300 &&
            res.data &&
            (("success" in res.data && res.data.success === true) || !("success" in res.data))
        ) {
            return {
                success: true,
                data: res.data as T,
            };
        } else {
            return { success: false };
        }
    } catch (e) {
        return { success: false };
    }
}
